import script from "./TableColumnsConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./TableColumnsConfig.vue?vue&type=script&setup=true&lang=js"

import "./TableColumnsConfig.vue?vue&type=style&index=0&id=3c92aedd&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c92aedd"]])

export default __exports__